import type { ReadonlyURLSearchParams } from 'next/navigation';

export const mainParamsQuery = [
  'token',
  'token_decrypted',
  'xcode',
  'XCODE',
  'redirect_url',
] as const;

export function destructureQueryParams(
  searchParams: ReadonlyURLSearchParams
): DestructuredQueryParams {
  const result = {} as DestructuredQueryParams;

  for (const queryItem of mainParamsQuery) {
    result[queryItem] = searchParams.get(queryItem);
  }

  return result;
}

export type DestructuredQueryParams = Partial<
  Record<(typeof mainParamsQuery)[number], string | null>
>;

export function removeParamForStringParams(stringParams: string, flag: string) {
  const params = new URLSearchParams(stringParams);
  const flagParams = flag.split(',');

  for (const flagParam of flagParams) {
    params.delete(flagParam);
  }

  return params.toString();
}

export function appendQueryParamsToUrl(
  nextPath: string,
  additionalParams?: string | string[],
  redirect_url?: string
) {
  const queryParams = new URLSearchParams(window.location.search);
  const url = new URL(nextPath, window.location.href);
  const searchParams = new URLSearchParams(url.search);

  if (redirect_url) {
    queryParams.delete('redirect_url');
  }

  if (queryParams.toString()) {
    for (const [key, value] of queryParams) {
      searchParams.set(key, value);
    }
  }

  if (!!additionalParams && typeof additionalParams === 'string') {
    const [key, value] = additionalParams.split('=');
    searchParams.set(key, value);
  }

  if (Array.isArray(additionalParams)) {
    additionalParams.forEach((param) => {
      const [key, value] = param.split('=');
      searchParams.set(key, value);
    });
  }

  url.search = searchParams.toString();

  return url;
}
